// extracted by mini-css-extract-plugin
export default {"textAnimated":"styles_text-animated__vQFMn","strokeOffset":"styles_stroke-offset__I7vYT"};